import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
// import {AuthInit} from './modules/auth'
import {ThemeModeProvider} from '../_metronic/partials'
import {useGetUser} from './almamotor/context/useGetUser'
import moment from 'moment'
import 'moment/locale/es'

moment.locale('es')

const App = () => {
  const {isLoading} = useGetUser()
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <ThemeModeProvider>
            {isLoading ? (
              <LayoutSplashScreen />
            ) : (
              <>
                <Outlet />
                <MasterInit />
              </>
            )}
          </ThemeModeProvider>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export {App}
